import { ventures, workspace } from './api';
import { logger } from '../helpers/logger';

export interface Banner {
  id: number;
  name: string;
  filePath: string;
  url: string;
  link?: string;
  isMobile: boolean;
}

export interface Product {
  id: number;
  productType: string;
  campaignId: number;
  banner: Banner;
}

export interface Campaign {
  id: number;
  name: string;
  status: string;
  active: boolean;
  products: Product[];
}

export interface BannerData {
  mobile: string;
  desktop: string;
  alt: string;
  idBanner: number;
  link?: string;
}

export interface PrescriptionParams {
  prescriptionId: number;
  doctorId: number;
}

export interface CampaignFilters {
  partner: string[];
  speciality?: string[];
  age?: string;
  prescriptionParams?: PrescriptionParams;
}

export const fetchActiveCampaigns = async (filters: CampaignFilters): Promise<Campaign[]> => {
  try {
    const response = await ventures.post<Campaign[]>('/campaigns/find-by-product/banner', filters);
    return response.data;
  } catch (error) {
    logger.error('Erro ao buscar campanhas:', error);
    throw error;
  }
};

export const processActiveBanners = (campaigns: Campaign[]): BannerData[] => {
  const bannerData: BannerData[] = [];

  campaigns.forEach((campaign) => {
    if (campaign.active) {
      let mobileBanner: Banner | null = null;
      let desktopBanner: Banner | null = null;
      let bannerLink: string | undefined;

      campaign.products.forEach((product) => {
        if (product.productType === 'banner' && product.banner) {
          mobileBanner = product.banner.isMobile ? product.banner : null;
          desktopBanner = !product.banner.isMobile ? product.banner : null;

          if (product.banner.link) {
            bannerLink = product.banner.link;
          }
        }
      });

      if (mobileBanner || desktopBanner) {
        bannerData.push({
          mobile: mobileBanner ? (mobileBanner as Banner).url : '',
          desktop: desktopBanner ? (desktopBanner as Banner).url : '',
          alt: desktopBanner ? (desktopBanner as Banner).name : mobileBanner ? (mobileBanner as Banner).name : 'Banner',
          link: bannerLink,
          idBanner: campaign.id,
        });
      }
    }
  });

  return bannerData;
};

export const fetchActiveBanners = async (filters: CampaignFilters): Promise<BannerData[]> => {
  try {
    const campaigns = await fetchActiveCampaigns(filters);
    if (!campaigns || campaigns?.length === 0) return [];
    return processActiveBanners(campaigns);
  } catch (error) {
    logger.error('Erro ao buscar banners ativos:', error);
    return [];
  }
};

export const fetchDoctorRqes = async (doctorId: number): Promise<any> => {
  try {
    if (!doctorId) return [];

    const response = await workspace.get(`/medico/${doctorId}/rqes`);
    return response.data;
  } catch (error) {
    logger.error('Erro ao buscar RQEs do médico:', error);
    return [];
  }
};
